import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getApiShipmentsOptions,
  type GetApiShipmentsError,
  type PageOfShipmentDto,
} from '@/api';

import {
  toHistoryQuery,
  type ResolvedHistorySearch,
} from '../lib/searchParams';

/** История отгрузок - страница закрытых отгрузок по фильтрам из адресной строки. */
export const useShipmentHistory = (
  resolved: ResolvedHistorySearch,
  // Тип возврата задан явно (TS2742), как у списка отгрузок.
): UseQueryResult<PageOfShipmentDto, GetApiShipmentsError> =>
  useQuery({
    ...getApiShipmentsOptions({ query: toHistoryQuery(resolved) }),
    placeholderData: (previous) => previous,
  });
